import React from 'react';
import { Helmet } from 'react-helmet';
import Header from '../Header';
import Footer from '../Footer';
import './layout.scss';

const Layout = ({ children, title = "Default Title", description = "Default description of the page" }) => {
	const documentTitle = title?.includes('Mereos') ? title : `${title} · Mereos Library`;

	return (
		<div className="page-layout">
			<Helmet>
				<title>{documentTitle}</title>
				<meta name="description" content={description} />
			</Helmet>
			<Header />
			<div className="content-container">
				{children}
			</div>
			<Footer />
		</div>
	);
};

export default Layout;
